// removed by extract-text-webpack-plugin
module.exports = {"img":"index-module_img_2V4ex","annotation":"index-module_annotation_2Q6t7","magnifier":"index-module_magnifier_10Pb7"};


//////////////////
// WEBPACK FOOTER
// ./client/components/itemPreviewer/index.module.css
// module id = 464
// module chunks = 1 3